/* eslint-disable no-unused-vars */

export enum INTERACTION_PARAMS {
  IS_BASKET = 'isBasket',
  SHOW_TARGET_WEIGHT = 'showTargetWeight',
}

export type InteractionParams = {
  [INTERACTION_PARAMS.IS_BASKET]: boolean;
  [INTERACTION_PARAMS.SHOW_TARGET_WEIGHT]?: boolean;
};

export type Params = InteractionParams;
export type DraftParams = Partial<Params>;
